const configuredAIUrl = process.env.REACT_APP_AI_URL?.trim();
const configuredApiUrl = process.env.REACT_APP_BASE_URL?.trim().replace(/\/+$/, '');

// Keep the assistant on the same environment as the rest of the app. A demo
// build can override REACT_APP_BASE_URL without accidentally calling production.
export const AI_BASE_URL = (configuredAIUrl || (
  configuredApiUrl ? `${configuredApiUrl}/ai` : 'http://localhost:4001'
)).replace(/\/+$/, '');
